// 부킹/SR에서 OOG 화면에만 속하는 값을 동일한 기준으로 정리한다.
export function hasOogDetails (container) {
  return ['02', '03'].includes(container.cgoTypCd) ||
    (container.cgoTypCd === '01' && container.cntrTypCd === 'FR' &&
      ['20', '40'].includes(container.cntrSzCd) &&
      ['02', '03'].includes(container.cntrCgoTypCd))
}

export function getOogResetFields (container) {
  if (hasOogDetails(container)) return {}

  const fields = ['orgLength', 'orgWidth', 'orgHeight', 'itemQty', 'bulkYn',
    'cmdtCd', 'oogCmdtNm', 'frgtWt', 'tareWtYn', 'itemCont', '_simulation',
    '_deadSpace', '_overLength', '_overWidth', '_overHeight']
  const reset = {}
  fields.forEach(key => { reset[key] = '' })
  // cmdtDsc는 Flexi Bag에서도 사용하는 값이므로 FB 저장 시에는 유지한다.
  if (container.cgoTypCd !== '06') reset.cmdtDsc = ''
  // 첨부번호/신청번호/위험물 상세/공통 Stowage Request는 여기서 비우지 않는다.
  return reset
}

export function canKeepDgOnContainerChange (container) {
  if (container.cgoTypCd !== '01' || container.cntrSzCd === '45') return false
  return ['GP', 'HC', 'OT', 'RF', 'RH', 'TK'].includes(container.cntrTypCd) ||
    (container.cntrTypCd === 'FR' && ['20', '40'].includes(container.cntrSzCd))
}
